import { render, staticRenderFns } from "./phoneShow.vue?vue&type=template&id=2aa84ed3&scoped=true&"
import script from "./phoneShow.vue?vue&type=script&lang=js&"
export * from "./phoneShow.vue?vue&type=script&lang=js&"
import style0 from "./phoneShow.vue?vue&type=style&index=0&id=2aa84ed3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa84ed3",
  null
  
)

export default component.exports